import tw, { styled } from 'twin.macro';

export const StyledContainer = styled.div`
  ${tw`flex flex-wrap gap-[12px]`}
`;
